// Developer-managed content for the landing page only.
// Update these values in code, not via the admin CMS.

export const LANDING_CONTACT_INFO_EMAIL = 'info@motostream.app';

export const LANDING_CONTACT_SUPPORT_EMAIL = 'support@motostream.app';

export const LANDING_SOCIAL_LINKS = {
  youtube: 'https://www.youtube.com/@MotoStream_app/shorts',
  facebook: 'https://www.facebook.com/profile.php?id=100093284682350',
  instagram: 'https://www.instagram.com/motostream_/',
  pinterest: 'https://www.pinterest.com/MotoStream_/?actingBusinessId=1133640674861132460',
  tiktok: 'https://www.tiktok.com/@motostream_app',
  x: 'https://x.com/MotoStream_app',
  linkedIn: 'https://www.linkedin.com/company/motostream/about/?viewAsMember=true',
  threads: 'https://www.threads.com/@motostream_',
};

export const LANDING_APP_LINKS = {
  appStoreUrl: 'https://apps.apple.com/us/app/motostream/id6504409673',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=app.motostream.application&hl=fr_CA',
};

export const hasLandingAppLinks = () => (
  Boolean(LANDING_APP_LINKS.appStoreUrl || LANDING_APP_LINKS.playStoreUrl)
);

export const isValidLandingSocialLink = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const trimmed = url.trim();
  return trimmed !== '' && trimmed !== '#';
};
